import { SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedAssetOrDefault, getFirstLinkedItemOrDefault, getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client/utils';
import { ENABLED } from '@r-and-a-shared-ui/utils';

export const virtual_waiting_room_configuration = (data: SSO_MODELS.VirtualWaitingRoomConfiguration) => {
  if (!data || !data?.elements) {
    return undefined;
  }
  const { elements } = data;

  const enabled = getSingleChoiceValue(elements?.virtual_waiting_room_enabled) === ENABLED;
  
  const analyticsTagConfig = getFirstLinkedItemOrDefault(elements?.analytics___tag_configuration);

  return {
    vwrEnabled: enabled,
    mainContent:  elements?.main_content?.value,
    title: elements?.title?.value,
    logo: getFirstLinkedAssetOrDefault(elements?.logo),
    queueNumberText: elements?.queue_number_text?.value,
    connectionErrorMessage: elements?.connection_error_message?.value,
    defaultContinuationUrl: elements?.default_continuation_url?.value,
    maxConcurrentRequestsAllowed: elements?.max_concurrent_requests_allowed?.value,
    realtimeEndpoint: elements?.realtime_endpoint?.value,
    exitCTALabel: elements?.exit_cta_label?.value,
    analyticsTagConfig: {
      googleTagManagerId: analyticsTagConfig?.elements?.google_tag_manager_id?.value || '',
      googleAnalyticsId: analyticsTagConfig?.elements?.google_analytics_id?.value || '',
    },
  };
};

export default virtual_waiting_room_configuration;
